import React, { useState } from "react";
import { styled } from "@mui/system";
import { featuredWorkflowInfo } from "../FeaturedWorkflow/FeaturedWorkflowInfo";
import MarketplaceCard from "./Templates/MarketplaceCard";
import config from "../../../config";
import MobileWorkflowBanner from "../MobileWorkflowBanner";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const MainContainer = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  "@media (max-width: 650px)": {
    alignItems: "center",
    flexDirection: "column",
    marginBottom: "3rem",
    width: "100%",
  },
});

const GridContainer = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
  gap: '16px',
  width: '100%',
  boxSizing: 'border-box',
  '@media (max-width: 650px)': {
    gridTemplateColumns: '1fr',
    padding: '16px',
  }
});

const FilterBar = styled(TextField)({
  maxWidth: "90%",
  minWidth: "300px",
  width: "50%",
  backgroundColor: "#1e1e1e",
  borderRadius: "5px",
  marginTop: "8px",
  marginBottom: "1rem",
  "& .MuiInputBase-input": {
    color: "#ffffff",
    padding: "8px 14px",
    height: "20px",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#333333",
    },
    "&:hover fieldset": {
      borderColor: "#4a4a4a",
    },
  },
  "& .MuiInputAdornment-root": {
    color: "#666666",
    height: "36px",
  },
});

const { templateName, templateDescription, href, image } = featuredWorkflowInfo;

/**
 *
 * @param {Array} templates Marketplace templates to be displayed as cards
 * @param {Object} categoryMapping Contains mapping of categoryID -> Name
 * @returns Template cards
 */
const Templates = ({ templates, categoryMapping }) => {
  const [filterText, setFilterText] = useState("");

  const filteredTemplates = templates.filter(template =>
    template.name && template.name.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <>
      <FilterBar
        type="text"
        placeholder="Filter templates..."
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      <GridContainer>
        {filteredTemplates.map(
          ({
            id,
            name,
            author,
            description,
            downloads,
            imagePath,
            categories,
            lastModified,
            projectId,
          }) => (
            <MarketplaceCard
              name={name}
              key={id}
              image={imagePath}
              author={author}
              description={description}
              downloads={downloads}
              categories={categories}
              lastModified={lastModified}
              href={config.TEMPLATES_API_ADDRESS + projectId}
              categoryMapping={categoryMapping}
            />
          )
        )}
      </GridContainer>
    </>
  );
};

export default Templates;
